import { createActions, using } from 'redux-box';

export const actions = createActions({
  requestImages: using("offset, search, gradeId"),
  setImages: using("images"),
  setPagination: using("pagination"),
  setLoading: using("isLoading"),
  createImage: using("payload"),
  updateImage: using("id, payload"),
  deleteImage: using("id")
});
